import { StarCheckOutlineIcon } from './StarCheckOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 94E37A05-1F0E-49EE-92D8-5FE57B54123F
 * name star-check-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-check-outline.svg
 * tags
 * - Shape 
 */
export const FavoriteCheckOutlineIcon = StarCheckOutlineIcon;
export default FavoriteCheckOutlineIcon